import React, { Component } from 'react';

const GridDataManuallyTouchedBills = ({ data, data2 }) => {
    console.log(data);
    return (
        <>
            <div className='col-md-7 col-xs-12 top-table-info'>
            <div className='row g-0'>
                <div className='col-md-5 col-xs-12'>
                    <label>Customer</label>
                </div>
                <div className='col-md-7 col-xs-12'>
                    <span>{data}</span>
                </div>
            </div>
            <div className='row g-0'>
                <div className='col-md-5 col-xs-12'>
                    <label>Category</label>
                </div>
                <div className='col-md-7 col-xs-12'>
                    <span>{data2.category}</span>
                </div>
            </div>
        </div>
            <div className='col-md-5 col-xs-12 top-table-info'>
                <div className='row g-0'>
                    <div className='col-md-6 col-xs-12'>
                        <label>Total Count</label>
                    </div>
                    <div className='col-md-6 col-xs-12'>
                        <span>{data2.total}</span>
                    </div>
                </div>
                <div className='row g-0'>
                    {/* <div className='col-md-6 col-xs-12'>
                        <label>Total Number of Bills</label>
                    </div>
                    <div className='col-md-6 col-xs-12'>
                        <span>{data.totalBills}</span>
                    </div> */}
                </div>
            </div>



        </>

    )
}

export default GridDataManuallyTouchedBills;
